module.exports = __webpack_public_path__ + "static/media/person-holding-phone.2268ac89.png";